export default {
  ImportedNoExclusion: 0, 
  ImportedWithExclusion: 1,
  Orphan: 2,
  NotImported: 3
};